import React from "react";
import { Link } from 'react-router-dom';
import footerlogo from '../images/footer-logo.png'
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo and Description */}
        <div className="footer-about">
          <p className="footer-description">
            At PetCrew, we connect you with the perfect pet for your family. From playful puppies
            to loyal cats, our furry friends are ready to bring joy to your home. We ensure healthy,
            happy pets raised with care. Trust PetCrew for a smooth, reliable adoption process.
            Join the PetCrew family today and experience unconditional love!
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3 className="footer-title">Quick Links</h3>
          <ul>
          <li><Link to="/">Home</Link></li>
            <li><Link to="/food">Food</Link></li>
            <li><Link to="/all-dog-breed">All Pets</Link></li>
            <li><a href="https://petcrew.in/terms-condition.php ">Terms And Conditions</a></li>
            {/* <li><a href="/contact-us">Contact Us</a></li> */}
          </ul>
        </div>

        {/* Locations */}
        <div className="footer-locations">
          <h3 className="footer-title">Locations</h3>
          <ul>
            <li>South Delhi</li>
            <li>Noida</li>
            <li>Gurgaon</li>
            <li>Greater Noida</li>
            <li>Chandigarh</li>
          </ul>
        </div>
        {/* Social Icons */}
        <div className="footer-social">
          <a href="#" className="social-icon">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#" className="social-icon">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
